export const isViewportMobile = () => {
  return getWindowPosition().width < 576;
};

export const getWindowPosition = () => {
  const w = window,
    d = document,
    documentElement = d.documentElement,
    body = d.getElementsByTagName('body')[0],
    _width = w.innerWidth || documentElement.clientWidth || body.clientWidth,
    _height =
      w.innerHeight || documentElement.clientHeight || body.clientHeight,
    _scrollTop = w.scrollTop || documentElement.scrollTop || body.scrollTop,
    _scrollLeft = w.scrollLeft || documentElement.scrollLeft || body.scrollLeft,
    _scrollWidth =
      w.scrollWidth || documentElement.scrollWidth || body.scrollWidth,
    _scrollHeight =
      w.scrollHeight || documentElement.scrollHeight || body.scrollHeight;

  return {
    width: _width,
    height: _height,
    scrollTop: _scrollTop,
    scrollLeft: _scrollLeft,
    scrollWidth: _scrollWidth,
    scrollHeight: _scrollHeight,
  };
};

export const encodeIt = (_json) => {
  const encoded = JSON.stringify(_json);
  return encodeURIComponent(encoded);
};

export const isRunningInProd = () => process.env.NODE_ENV === 'production';

// remove undefined from entire object
export const cleanedObject = (obj) => {
  function isReferenceField(obj) {
    return !!obj && !!obj.firestore;
  }
  Object.keys(obj).forEach((key) => {
    if (isReferenceField(obj[key])) {
      delete obj[key];
    } else if (obj[key] && typeof obj[key] === 'object') {
      cleanedObject(obj[key]);
    } else if (obj[key] === undefined) {
      delete obj[key];
    }
  });
  return obj;
  // _.pickBy(obj, (v) => v !== undefined);
};

export const scrollIntoViewSmooth = (el) => {
  if (!el?.scrollIntoView) return;

  setTimeout(() => {
    function inIframe() {
      try {
        return window.self !== window.top;
      } catch (e) {
        return true;
      }
    }

    try {
      // fix: it as scrolling the parent frame
      const block = inIframe() ? 'nearest' : 'start';
      el.scrollIntoView({
        block,
        behavior: 'smooth',
      });
    } catch (err) {
      console.warn('[scrollIntoViewSmooth] error');
      console.error(err);
    }
  }, 200);
};
